import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { jsx } from "features/feature";
import { coerceComponent, render } from "util/vue";
import { computed, toRef, unref } from "vue";
import Game from "./components/Game.vue";
import GameOverScreen from "./components/GameOverScreen.vue";
import NaNScreen from "./components/NaNScreen.vue";
import Nav from "./components/Nav.vue";
import TPS from "./components/TPS.vue";
import projInfo from "./data/projInfo.json";
import themes from "./data/themes";
import settings, { gameComponents } from "./game/settings";
import "./main.css";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const useHeader = projInfo.useHeader;
const theme = computed(() => themes[settings.theme].variables);
const showTPS = toRef(settings, "showTPS");

const gameComponent = computed(() => {
    return coerceComponent(jsx(() => <>{gameComponents.map(render)}</>));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "modal-root",
      style: _normalizeStyle(_unref(theme))
    }, null, 4),
    _createElementVNode("div", {
      class: _normalizeClass(["app", { useHeader: _unref(useHeader) }]),
      style: _normalizeStyle(_unref(theme))
    }, [
      (_unref(useHeader))
        ? (_openBlock(), _createBlock(Nav, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(Game),
      (unref(_unref(showTPS)))
        ? (_openBlock(), _createBlock(TPS, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(GameOverScreen),
      _createVNode(NaNScreen),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(gameComponent))))
    ], 6)
  ], 64))
}
}

})